import { DataBuilderOption } from '../../components/ui/DataBuilderOption';

type UnitOptionProps = {
  value: string;
  label: string;
  detail?: string;
  description?: string | null;
  isSelected: boolean;
  onClick: () => void;
};

export const UnitOption = ({
  value,
  label,
  detail,
  description,
  isSelected,
  onClick,
}: UnitOptionProps) => {
  return (
    <DataBuilderOption
      data-testid={`data-builder-unit-option-${value}`}
      isSelected={isSelected}
      onClick={onClick}
      startSlot={<DataBuilderOption.CheckBox isSelected={isSelected} />}
      endSlot={
        description ? (
          <DataBuilderOption.DescriptionTooltip description={description} />
        ) : undefined
      }
      endSlotAlignment="center"
    >
      <DataBuilderOption.Label>{label}</DataBuilderOption.Label>
      {detail && (
        <DataBuilderOption.Description>{detail}</DataBuilderOption.Description>
      )}
    </DataBuilderOption>
  );
};

type ColumnOptionCardProps = {
  keyId: string;
  label: string;
  description?: string | null;
  isSelected: boolean;
  isRequired?: boolean;
  isDisabled?: boolean;
  onToggle: () => void;
};

export const ColumnOptionCard = ({
  keyId,
  label,
  description,
  isSelected,
  isRequired = false,
  isDisabled = false,
  onToggle,
}: ColumnOptionCardProps) => {
  const detail = isRequired ? 'Required' : '';
  const disabled = isDisabled || isRequired;
  return (
    <DataBuilderOption
      data-testid={`data-builder-column-option-${keyId}`}
      style={isRequired ? { cursor: 'default' } : undefined}
      isSelected={isSelected}
      disabled={disabled}
      onClick={onToggle}
      startSlot={<DataBuilderOption.CheckBox isSelected={isSelected} />}
      endSlot={
        description ? (
          <DataBuilderOption.DescriptionTooltip description={description} />
        ) : undefined
      }
      endSlotAlignment="center"
    >
      <DataBuilderOption.Label>{label}</DataBuilderOption.Label>
      {detail && (
        <DataBuilderOption.Description>{detail}</DataBuilderOption.Description>
      )}
    </DataBuilderOption>
  );
};
